import { useEffect, useState } from 'react';
import { useFetchCallback } from '@services/services';
import toast from 'react-hot-toast';
import { Alert } from '@interfaces/general';

interface AlertFilter {
  date: string;
  plan?: string;
}

export const useGetAlert = (filter: AlertFilter) => {
  const [alerts, setAlerts] = useState<Alert[]>([]);

  const { isFetching, call } = useFetchCallback<
    undefined,
    {
      results: Alert[];
    }
  >('get', '', 'v2');

  const fetchAlert = async () => {
    if (!filter.plan) {
      return undefined;
    }
    try {
      const fullUrl = `announcements?date=${filter.date}&plan=${filter.plan}&is_active=true&announcement_type=bottom_bar`;
      const response = await call({ path: fullUrl });
      if (response) {
        setAlerts(response.results || []);
      }
    } catch {
      toast.error('Error al obtener la alerta');
    }
  };

  useEffect(() => {
    if (filter?.date && filter?.plan) {
      fetchAlert();
    }
  }, [filter.date, filter.plan]);

  return {
    alerts,
    isFetching,
    fetchAlert,
  };
};
